import UIAlert from 'UIComponents/alert/UIAlert';
import { useIsSensitiveDataEnabled } from '../hooks/useSensitiveDataSettings';
import { GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
export const SensitiveDataEditorBanner = ({
  bannerText,
  onClose
}) => {
  const {
    loading,
    data
  } = useIsSensitiveDataEnabled();
  if (loading || !(data !== null && data !== void 0 && data.sensitiveDataEnabled)) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "p-x-3 p-bottom-3",
    style: {
      backgroundColor: GYPSUM
    },
    "data-test-id": "sensitive-data-banner",
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: "warning",
      onClose: () => {
        onClose();
      },
      closeable: true,
      children: bannerText
    })
  });
};
SensitiveDataEditorBanner.displayName = 'SensitiveDataEditorBanner';